import { h, render } from 'preact';
import CountDown from './countdown';
import Utils from '../../utils';
import {Context, ContextUtil} from '../context';
import Formula from './formula';
import ToolTip from './tooltip';
import CiblerApi from '../ciblerApi';

const replaceParameters = (c, props) => {
  let content = c;

  content = content.replace(/({{[a-zA-Z0-9\s\=]+)(\<+.*?\>+)([a-zA-Z0-9\s\=]+}})/gm, '$1$3');

  content = content.replace(/{{countdown\s?(\S*?\s?\S*?)(?:\slabel=(\w*))?}}/g, '<cibler_countdown data-time="$1" data-label="$2"></cibler_countdown>');

  content = content.replace(/{{image}}/g, `<img style="height: 100%;width: 100%;" id="cibler_image" src="${Context.clientUrl}campaigns/assets/${props.campaignId}/${Context.device}${Utils.getCampaignData(props.campaigndata.image, '')}" />`);

  content = content.replace(/{{redirectUrl}}/g, Utils.getCampaignData(props.campaigndata.redirecturl, '#'));

  content = content.replace(/{{formula\s?(.*)}}/g, '<cibler_formula data-formula="$1"></cibler_formula>');

  content = content.replace(/{{lastCart\s?(?:%20)?(?:&nbsp;)?(.*?)\s?(?:\sproduct=(\w*))?}}/g, (cor, p1) => ContextUtil.getParamFromContext(`lastCart.${p1}`));

  content = content.replace(/{{crossSell\s?(?:%20)?(?:&nbsp;)?(.*?)}}/g, (cor, p1) => ContextUtil.getParamFromContext(`${props.campaignId}.crossSell.${p1}`));

  content = content.replace(/{{redirectScroll\s?(?:&nbsp;)?(.*?)\s?(?:&nbsp;)?\|\|\s?(.*?)\s?\|\|\s?(.*?)\s?}}/g, (cor, p1, p2, p3) => (
    `<a href="${p2}?ciblerScrollAnchor=${encodeURIComponent(p3)}&ciblerScrollCampaign=${props.campaignId}">${p1}</a>`
  ));

  content = content.replace(/{{context\s?(.*)}}/g, (cor, p1) => ContextUtil.getParamFromContext(p1));

  content = content.replace(/{{tooltip\s?(.*?)\s?\|\|\s?(.*?)\s?}}/g, (cor, p1, p2) => (
    `<cibler_tooltip data-button="${
      encodeURIComponent(p1)}" data-tip="${
      encodeURIComponent(p2)}"></cibler_tooltip>`
  ));

  return content;
};

const insertCustomComponents = (props) => {
  const body = document.getElementById(`WioGameBG_${props.campaignId}`);
  if (!body) return;
  const countdown = body.querySelectorAll('cibler_countdown');
  if (countdown && countdown.length) {
    for (let i = 0; i < countdown.length; i += 1) {
      render(
        <CountDown
          campaignId={props.campaignId}
          time={countdown[i].getAttribute('data-time')}
          label={countdown[i].getAttribute('data-label')}
          showAll={Utils.getCampaignData(props.countdownshowall, false)}
          refuseBlock={props.refuseBlock}
        />,
        countdown[i],
      );
    }
  }
  const formula = body.querySelectorAll('cibler_formula');
  if (formula && formula.length) {
    for (let i = 0; i < formula.length; i += 1) {
      formula[0].innerHTML = Formula.resolve(formula[0].getAttribute('data-formula'));
    }
  }
  const tooltip = body.querySelectorAll('cibler_tooltip');
  if (tooltip && tooltip.length) {
    for (let i = 0; i < tooltip.length; i += 1) {
      render(
        <ToolTip
          button={decodeURIComponent(tooltip[i].getAttribute('data-button'))}
          tip={decodeURIComponent(tooltip[i].getAttribute('data-tip'))}
        />,
        tooltip[i],
      );
    }
  }
};

const contextCondition = (props, resolve) => {
  const promiseList = [];

  const contents = Utils.getCampaignData(props.campaigndata?.content, '') + Utils.getCampaignData(props.campaigndata?.hiddenGiftContent, '');
  if (contents && contents.includes) {
    if (contents.includes('{{lastCart')) {
      promiseList.push(CiblerApi.getLastCart(false));
    }

    if (contents.includes('{{crossSell')) {
      promiseList.push(CiblerApi.getSimilarProduct(props));
    }
  }

  const condition = Utils.getCampaignData(props.campaigndata?.contextCondition, '');
  if (condition) {
    promiseList.push(new Promise(res => res(Formula.resolve(condition))));
  }

  if (!promiseList.length) return resolve(true);

  Promise.all(promiseList).then((results) => {
    for (let i = 0; i < results.length; i += 1) {
      if (!results[i]) {
        resolve(false);
        return;
      }
    }

    resolve(true);
  }).catch(() => resolve(false));

  return false;
};

export {
  contextCondition,
  insertCustomComponents,
  replaceParameters,
};
